import { JobCreateDto, JobUpdateDto, Pagination } from '@libs/dto';
import { Job } from '@libs/models';

import { api } from '../common.api';

export const jobApi = api.injectEndpoints({
  endpoints: (build) => ({
    jobCreate: build.mutation<Job, JobCreateDto>({
      query: (body) => ({
        url: '/job',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Job'],
    }),
    jobUpdate: build.mutation<Job, JobUpdateDto>({
      query: (body) => ({
        url: `/job/${body.id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Job'],
    }),
    jobIndex: build.query<Pagination<Job>, { page?: number; limit?: number }>({
      query: ({ page = 1, limit = 10 } = {}) => ({
        url: '/job',
        method: 'GET',
        params: { page, limit },
      }),
      providesTags: ['Job'],
    }),
    jobSearch: build.query<Pagination<Job>, { q: string; page?: number; limit?: number }>({
      query: ({ q, page = 1, limit = 10 }) => ({
        url: '/job/search',
        method: 'GET',
        params: { q, page, limit },
      }),
      providesTags: ['Job'],
    }),
    jobView: build.query<Job, number>({
      query: (id) => ({
        url: `/job/${id}`,
        method: 'GET',
      }),
      providesTags: ['Job'],
    }),
    jobFindByRooftop: build.query<Pagination<Job>, { rooftopId: number; page?: number; limit?: number }>({
      query: ({ rooftopId, page = 1, limit = 10 }) => ({
        url: `/job/rooftop/${rooftopId}`,
        method: 'GET',
        params: { page, limit },
      }),
      providesTags: ['Job'],
    }),
    jobDelete: build.mutation<Job, number>({
      query: (id) => ({
        url: `/job/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Job'],
    }),
  }),
});

export const {
  useJobCreateMutation,
  useJobUpdateMutation,
  useJobIndexQuery,
  useJobSearchQuery,
  useJobViewQuery,
  useJobFindByRooftopQuery,
  useJobDeleteMutation,
} = jobApi;
